import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { Button, Stack, Typography } from '@mui/material';

import ErrorBox from './components/ErrorBox';
import { ErrorFallBackTypes } from './types';



const ErrorFallback = ({handleClick}: ErrorFallBackTypes) => {
    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                height: '100vh',
                justifyContent: 'center',
                background: 'white'
            }}
        >
            <ErrorBox
                header={
                    <Stack
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        style={{ opacity: 1 }}
                    >
                        <SentimentVeryDissatisfiedIcon
                            sx={{
                                fontSize: 80
                            }}
                        />
                        <span>Oh no, something went wrong</span>
                    </Stack>
                }
                description={
                    handleClick && (
                        <Typography>
                            <Button
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 'normal',
                                    color: "#7122ff",
                                    '&:hover': {backgroundColor: 'rgba(113, 34, 255, 0.04)'}
                                }}
                                className="error-fallback-button"
                                onClick={handleClick}
                            >
                                Click Here to Return Home
                            </Button>
                        </Typography>
                    )
                }
            />
        </div>
    );
};

export default ErrorFallback;
